import React, { useEffect, useState } from "react";
import { TextField, MenuItem } from "@mui/material";
import styles from "./style.module.scss";

const DateFilter = ({ onChange,resetTrigger,value, hideOptions = [] }) => {
    
  const [type, setType] = useState("");
  const [dates, setDates] = useState({
    date_from: "",
    date_to: "",
  });

  useEffect(() => {
  setType("");
  setDates({
    date_from: "",
    date_to: "",
  });
}, [resetTrigger]);

useEffect(() => {
  if (!value) return;

  const { date_from, date_to } = value;

  // No dates → reset
  if (!date_from && !date_to) {
    setType("");
    setDates({ date_from: "", date_to: "" });
    return;
  }

  const today = new Date();
  const format = (d) => d.toISOString().split("T")[0];

  const todayStr = format(today);

  const y = new Date();
  y.setDate(today.getDate() - 1);

  const t = new Date();
  t.setDate(today.getDate() + 1);

  // Match type
  if (date_from === todayStr && date_to === todayStr) {
    setType("today");
  } else if (date_from === format(y) && date_to === format(y)) {
    setType("yesterday");
  } else if (date_from === format(t) && date_to === format(t)) {
    setType("tomorrow");
  } else {
    setType("custom");
  }

  setDates({
    date_from: date_from || "",
    date_to: date_to || "",
  });
}, [value]);
  const formatDate = (date) => date.toISOString().split("T")[0];

  const handleTypeChange = (e) => {
    const value = e.target.value;
    setType(value);

    const today = new Date();
    let from = "";
    let to = "";

    if (value === "today") {
      from = to = formatDate(today);
    }

    if (value === "yesterday") {
      const d = new Date();
      d.setDate(today.getDate() - 1);
      from = to = formatDate(d);
    }

    if (value === "tomorrow") {
      const d = new Date();
      d.setDate(today.getDate() + 1);
      from = to = formatDate(d);
    }

    if (value !== "custom") {
      const updated = { date_from: from, date_to: to };
      setDates(updated);
      onChange(updated);
    }
  };

  const handleDateChange = (e) => {
    const { name, value } = e.target;

    const updated = {
      ...dates,
      [name]: value,
    };

    setDates(updated);
    setType("custom");

    onChange(updated);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      
      {/* 🔽 Select Dropdown */}
      <TextField
  select
  fullWidth
  label="Select Date Filter"
  value={type}
  onChange={handleTypeChange}
//   SelectProps={{
//    MenuProps: {
//   PaperProps: {
//     sx: { zIndex: 11000 },
//   },
// }
//   }}
>
  <MenuItem value="" disabled selected>
    Select
  </MenuItem>
  <MenuItem value="today">Today</MenuItem>
    {!hideOptions.includes("yesterday") && (
  <MenuItem value="yesterday">Yesterday</MenuItem>
  )}
  <MenuItem value="tomorrow">Tomorrow</MenuItem>
  <MenuItem value="custom">Custom</MenuItem>
</TextField>

      {/* 📅 Custom Date Fields */}
      {type === "custom" && (
        <div style={{ display: "flex", gap: "10px" }}>
          <TextField
            fullWidth
            type="date"
            name="date_from"
            label="From"
            value={dates.date_from}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            fullWidth
            type="date"
            name="date_to"
            label="To"
            value={dates.date_to}
            onChange={handleDateChange}
            InputLabelProps={{ shrink: true }}
          />
        </div>
      )}
    </div>
  );
};

export default DateFilter;